export default "__VITE_ASSET__DW6145Fe__"